/* eslint-disable react/prop-types */
import React from 'react'
import withIconStyles from './HOC/withIconStyles'
import SVG from './common/SVG'

const IconLeftRotate = (props) => (
  <SVG
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.73 2.66487e-05C13.6632 -0.00378102 11.6161 0.400489 9.7059 1.18965C7.79573 1.9788 6.06014 3.13732 4.59872 4.59875C3.1373 6.06017 1.97879 7.79574 1.18963 9.70591C0.400475 11.6161 -0.00378102 13.6633 2.66496e-05 15.73H15.73V31.46C19.8791 31.4592 23.8599 29.8193 26.8055 26.8973C29.7512 23.9753 31.4232 20.0079 31.4575 15.8589C31.4918 11.71 29.8856 7.71548 26.9886 4.7452C24.0916 1.77492 20.1385 0.0694101 15.99 2.66487e-05H15.73Z"
      fill="#CECECD"
    />
    <path
      d="M11.3101 7.15C18.8501 4.42 27.6901 11.7 24.9601 19.63"
      stroke="black"
    />
    <path
      d="M14.1705 9.88001L7.02051 10.01L10.4005 3.64001L14.1705 9.88001Z"
      fill="black"
    />
    <path d="M22.3606 16.9V24.05L28.6006 20.28L22.3606 16.9Z" fill="black" />
  </SVG>
)

export default withIconStyles(IconLeftRotate)
